<template>
  <v-container v-if="offerData.id" :loading="loading">
    <v-row>
      <v-col>
        <v-data-table
          v-model="fulfillmentCreation.positions"
          :headers="headers"
          :items="offerData.positions"
          dense
          disable-sort
          disable-pagination
          hide-default-footer
          show-select
        >
          <template #body="{items: positions, select, isSelected}">
            <tbody>
              <template v-for="(position, posindex) in positions">
                <tr :key="position.id" style="background-color: gray;">
                  <td><v-simple-checkbox :value="position.fulfilled ? position.fulfilled : isSelected(position)" :ripple="false" :disabled="position.fulfilled" @input="select(position, $event)" /></td>
                  <td>{{ posindex + 1 }}</td>
                  <td>{{ position.title }}</td>
                </tr>
                <template v-for="(positionItem, itemindex) in position.items">
                  <tr :key="positionItem.id">
                    <td />
                    <td>{{ posindex + 1 }}.{{ itemindex+1 }}</td>
                    <td>{{ positionItem.title }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="fulfillmentCreation.startDate"
              label="Startdatum"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="fulfillmentCreation.startDate"
            :active-picker.sync="startDateActivePicker"
            :max="
              new Date(
                new Date().setMonth(new Date().getMonth() + 6)
              )
                .toISOString()
                .substr(0, 10)
            "
            :min="
              new Date(
                new Date().setMonth(new Date().getMonth() - 6)
              )
                .toISOString()
                .substr(0, 10)
            "
          />
        </v-menu>
      </v-col>
      <v-col>
        <v-btn class="primary" @click="submit">
          Übergabe speichern
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Übergabe',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      contract: {
         type: Object,
         required: true,
      },
   },
   data () {
      return {
         loading: true,
         headers: [
            {
               text: 'Pos.',
               align: 'start',
               filterable: false,
               value: 'pos',
            },
            { text: 'Beschreibung', value: 'title' },
         ],
         fulfillmentCreation: this.$inertia.form({
            startDate: new Date().toISOString().substr(0, 10),
            positions: [],
         }),
         startDateActivePicker: 'MONTH',
      }
   },
   watch: {
      startDateMenu (val) {
         val && setTimeout(() => (this.startDateActivePicker = 'MONTH'))
      },
   },
   methods: {
      positionBackground (pos) {
         return {
            backgroundColor:
          pos !== undefined && !String(pos).includes('.')
             ? 'gray'
             : 'transparent',
         }
      },

      itemText (item) {
         return item.product.last_data[0].name + ' - ' + item.last_data[0].name
      },
      positionText (item) {
         return item.last_data[0].name
      },
      submit () {
         this.fulfillmentCreation.post(
            this.route('contracts.fulfillments.store', {
               contract: this.contract.id,
            })
         )
      }
   },
}
</script>
